const { getRfidEnabledRelations } = require('@sstdev/lib_metadata-config');

module.exports = getRfidEnabledRelations;
